import React from 'react';
import { FadeIn } from './FadeIn';
export function BonusSection() {
  const bonos = [{
    label: 'Bono 1',
    title: 'Kit CUD: Cómo acompañar el trámite sin perderte',
    desc: 'Guía completa del Certificado Único de Discapacidad: rol de la fono, documentación y modelo de informe para la Junta Evaluadora.'
  }, {
    label: 'Bono 2',
    title: '30 Plantillas de WhatsApp para el consultorio',
    desc: 'Mensajes listos para copiar y pegar: primer contacto, confirmación de turno, cobro de ausencias, aumento de honorarios y más.'
  }, {
    label: 'Bono 3',
    title: 'Diccionario de diagnósticos fonoaudiológicos',
    desc: 'Definiciones claras con criterios DSM-5 y CIE-11 para los diagnósticos más frecuentes: TEL, TEA, dislalia, disfluencia, hipoacusia.'
  }, {
    label: 'Bono 4',
    title: '12 Fichas de pautas para el hogar por área',
    desc: 'Fichas listas para entregar a las familias: lenguaje, habla, voz, deglución, lectoescritura, TEA y comunicación aumentativa.'
  }, {
    label: 'Bono 5',
    title: 'Guía de fees: cómo subir honorarios sin perder pacientes',
    desc: 'Cómo y cuándo comunicar un aumento, qué decirle a cada tipo de familia y cómo sostener el valor sin disculparse.'
  }, {
    label: 'Bono 6',
    title: 'Planificador anual del consultorio',
    desc: 'Calendario con todas las fechas críticas del año: informes semestrales, vencimientos de RNP, facturación mensual y más.'
  }];
  return <section className="bg-brand-green py-16 md:py-24 px-4 md:px-6" data-id="element-25">
      <div className="max-w-6xl mx-auto" data-id="element-26">
        <FadeIn data-id="element-27">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-white/60 mb-3" data-id="element-28">
            Los 6 bonos incluidos
          </p>
          <h2 className="font-serif text-white text-3xl md:text-[42px] font-bold leading-[1.2]" data-id="element-29">
            Cada bono resuelve un problema que el tomo nombra
          </h2>
          <div className="w-12 h-[2px] bg-white/30 mt-5 mb-10 md:mb-12" data-id="element-30" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-31">
          {bonos.map((b, i) => <FadeIn key={i} delay={i * 0.06} data-id="element-32">
              <div className="bg-white/[0.08] border border-white/12 rounded-[10px] p-6 h-full hover:bg-white/[0.12] transition-colors" data-id="element-33">
                <p className="text-[10px] font-semibold tracking-[0.12em] uppercase text-white/50 mb-2" data-id="element-34">
                  {b.label}
                </p>
                <h3 className="text-white font-semibold text-[15px] leading-snug mb-2" data-id="element-35">
                  {b.title}
                </h3>
                <p className="text-white/65 text-[13px] leading-relaxed" data-id="element-36">
                  {b.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}